/*
 * @FilePath: \hotOrder-frontend\src\router\modules\suggestCollect.js
 * @Description: 人民意见征集路由
 */
import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};

export default {
  path: "/point",
  name: "point",
  redirect: {
    name: "pointConfig",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/point/pointConfig",
      name: "pointConfig",
      meta: {
        ...meta,
        title: "积分配置",
      },
      component: () => import("@/pages/point/pointConfig.vue"),
    },
    {
      path: "/point/pointLog",
      name: "pointLog",
      meta: {
        ...meta,
        title: "积分日志",
      },
      component: () => import("@/pages/point/pointLog.vue"),
    },
    {
      path: "/point/exchangePoint",
      name: "exchangePoint",
      meta: {
        ...meta,
        title: "兑换点管理",
      },
      component: () => import("@/pages/point/exchangePoint.vue"),
    },
    {
      path: "/point/pointsRedemption",
      name: "pointsRedemption",
      meta: {
        ...meta,
        title: "积分兑换",
      },
      component: () => import("@/pages/point/pointsRedemption.vue"),
    },
    {
      path: "/point/lqsxNewList",
      name: "lqsxNewList",
      meta: {
        ...meta,
        title: "两企三新名单",
      },
      component: () => import("@/pages/point/lqsxNewList.vue"),
    },
  ],
};
